// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"a19c38e9","845":"81ebfd0f"}[chunkId] + ".chunk.js";
};